import { useEffect, useState } from "react";
import "./FormRegister.scss";
import { Button, Checkbox, ConfigProvider, Form, Input, Select } from "antd";
import { Link, useNavigate } from "react-router-dom";
import {
  createNewUser,
  getListSecurityQuestion,
  getListUsers,
} from "../../services/register/register";
import { FaChevronDown } from "react-icons/fa6";
import { checkEmailValid } from "../../helper/checkEmail";
import { checkExistEmail } from "../../services/login/login";
import { generateToken } from "../../helper/generateToken";
import { AllAvatar } from "../../helper/AvatarRandom";

function FormRegister() {
  const [securityQuestion, setSecurityQuestion] = useState([]);
  const [iconRotate, setIconRotate] = useState(false);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const validateMessage = {
    string: {
      min: "${label} phải có ít nhất ${min} kí tự",
    },
  };

  useEffect(() => {
    const fetchApi = async () => {
      const res = await getListSecurityQuestion();
      const listResFinal = res.map((item) => ({
        value: item.id,
        label: item.question,
      }));
      setSecurityQuestion(listResFinal);
    };
    fetchApi();
  }, []);

  const handleSubmit = async (e) => {
    setLoading(true);
    setStatus("loading");

    const email = e.email;
    const fullName = e.fullName;
    const password = e.password;
    const idQuestion = e.idSecurityQuestion;
    const answer = e.answer;
    const username = e.username;

    const emailValid = checkEmailValid(email);
    const emailExist = await checkExistEmail(email);
    const totalUsers = await getListUsers();

    setTimeout(async () => {
      if (totalUsers.length === 5) {
        setStatus("maxUsers");
        setLoading(false);
        return;
      }

      if (!emailValid) setStatus("invalidEmail");
      else if (emailExist.length > 0) setStatus("existEmail");
      else {
        const randomAvt =
          AllAvatar[Math.floor(Math.random() * AllAvatar.length)].avt;

        const dataNewUser = {
          fullName: fullName,
          email: email,
          password: password,
          idSecurityQuestion: idQuestion,
          answer: answer,
          token: generateToken(),
          avatar: randomAvt,
          username: username,
          status: "Hoạt động hôm nay",
          follower: 0,
          following: 0,
          liked: [],
          cart: [],
        };

        const newUser = await createNewUser(dataNewUser);

        if (newUser) {
          setStatus("success");
          setTimeout(() => {
            navigate("/login");
          }, 1500);
        }
      }
      setLoading(false);
    }, 2000);
  };

  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            Form: {
              itemMarginBottom: 18,
              verticalLabelPadding: "0 0 5px",
            },
            Select: {
              hoverBorderColor: "#000",
              activeBorderColor: "#000",
              optionSelectedBg: "	#000",
              optionSelectedColor: "#fff",
            },
            Checkbox: {
              colorPrimary: "#000",
              colorPrimaryHover: "#000",
            },
            Button: {
              defaultBg: "#000",
              defaultColor: "#fff",
              defaultHoverColor: "#000",
              defaultHoverBorderColor: "#000",
              defaultActiveBorderColor: "#000",
              defaultActiveColor: "#000",
              fontWeight: 700,
            },
          },
        }}
      >
        <Form
          name="basic"
          size="large"
          layout="vertical"
          requiredMark={true}
          autoSave="on"
          autoComplete="on"
          validateMessages={validateMessage}
          onFinish={handleSubmit}
          className="form-register"
        >
          <Form.Item
            label="Họ tên"
            style={{ fontWeight: 500 }}
            name="fullName"
            rules={[
              { required: true, message: "Vui lòng nhập họ tên!" },
              { max: 30, message: "Họ và tên không được vượt quá 30 kí tự!" },
            ]}
          >
            <Input
              placeholder="Nguyễn Văn A"
              className="form-register-fullName"
            />
          </Form.Item>

          <Form.Item
            label="Tên hiển thị"
            name="username"
            style={{ fontWeight: 500 }}
            rules={[
              { required: true, message: "Vui lòng nhập tên hiển thị!" },
              {
                max: 15,
                message: "Tên hiển thị không được vượt quá 15 kí tự!",
              },
            ]}
          >
            <Input
              placeholder="nguyenvana"
              className="form-register-username"
            />
          </Form.Item>

          <Form.Item
            label="Email"
            style={{ fontWeight: 500 }}
            name="email"
            rules={[
              { required: true, message: "Vui lòng nhập email!" },
              { max: 40, message: "Email không được vượt quá 40 kí tự!" },
            ]}
          >
            <Input
              placeholder="name@gmail.com"
              className="form-register-email"
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="Mật khẩu"
            style={{ fontWeight: 500 }}
            rules={[
              { required: true, message: "Vui lòng nhập mật khẩu!" },
              { type: "string", min: 8 },
              { max: 20, message: "Mật khẩu không được vượt quá 20 kí tự!" },
            ]}
          >
            <Input.Password
              variant="borderless"
              placeholder="name1234"
              className="form-register-pass"
            />
          </Form.Item>

          <Form.Item
            name="idSecurityQuestion"
            label="Câu hỏi bảo mật"
            style={{ fontWeight: 500 }}
            rules={[
              { required: true, message: "Vui lòng chọn câu hỏi bảo mật" },
            ]}
          >
            <Select
              className="form-register-select"
              open={iconRotate}
              onClick={() => setIconRotate(true)}
              onFocus={() => setIconRotate(true)}
              onBlur={() => setIconRotate(false)}
              style={{ fontWeight: 480 }}
              options={securityQuestion}
              placeholder="Vui lòng chọn câu hỏi bảo mật"
              allowClear
              suffixIcon={
                <FaChevronDown
                  className={`icon-fachev ${iconRotate ? "rotate" : ""}`}
                />
              }
            ></Select>
          </Form.Item>

          <Form.Item
            label="Câu trả lời"
            name="answer"
            style={{ fontWeight: 500 }}
            rules={[
              { required: true, message: "Vui lòng trả lời câu hỏi bảo mật!" },
              { max: 20, message: "Câu trả lời không được vượt quá 20 kí tự!" },
            ]}
          >
            <Input
              placeholder="Câu trả lời cho câu hỏi bảo mật"
              className="form-register-answer"
            />
          </Form.Item>

          <Form.Item
            name="accept"
            label={null}
            valuePropName="checked"
            style={{ fontWeight: 500, margin: "0px 0px 50px 0px" }}
            rules={[
              {
                validator: (_, value) =>
                  value
                    ? Promise.resolve()
                    : Promise.reject(
                        new Error(
                          "Vui lòng Chấp nhận các Điều khoản và Chính sách bảo mật để đăng kí tài khoản!"
                        )
                      ),
              },
            ]}
          >
            <Checkbox className="form-register-checkbox">
              Chấp nhận các <Link className="accept">Điều khoản</Link> và{" "}
              <Link className="accept">Chính sách bảo mật</Link>
            </Checkbox>
          </Form.Item>

          <div className="form-register-notification">
            {status === "loading" && (
              <div className="form-register-notification-status loading">
                Đang xử lí, vùi lòng đợi trong giây lát...
              </div>
            )}

            {status === "maxUsers" && (
              <div className="form-register-notification-status maxUsers">
                Đăng kí không thành công! Hệ thống đang quá tải!
              </div>
            )}

            {status === "invalidEmail" && (
              <div className="form-register-notification-status invalidEmail">
                Email không hợp lệ!
              </div>
            )}

            {status === "existEmail" && (
              <div className="form-register-notification-status existEmail">
                Email đã tồn tại!
              </div>
            )}

            {status === "success" && (
              <div className="form-register-notification-status success">
                Đăng kí thành công. Đang chuyển hướng tới đăng nhập!
              </div>
            )}
          </div>

          <Form.Item label={null}>
            <Button
              htmlType="submit"
              className="form-register-btnRegister"
              loading={loading}
              disabled={loading}
            >
              {!loading && "Đăng kí"}
            </Button>
          </Form.Item>
        </Form>
      </ConfigProvider>
    </>
  );
}

export default FormRegister;
